
/**
 * Converts a UTC date string to IST Date object
 * IST is UTC+5:30
 */
export const convertUTCtoIST = (utcDateString: string | Date): Date => {
  const utcDate = new Date(utcDateString)
  const istString = utcDate.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
  return new Date(istString)
}

/**
 * Gets the IST date string in YYYY-MM-DD format for grouping
 */
export const getISTDateString = (utcDateString: string | Date): string => {
  const istDate = convertUTCtoIST(utcDateString)
  const year = istDate.getFullYear()
  const month = String(istDate.getMonth() + 1).padStart(2, "0")
  const day = String(istDate.getDate()).padStart(2, "0")
  return `${year}-${month}-${day}`
}

/**
 * Formats IST time for display (HH:MM AM/PM)
 */
export const formatISTTime = (utcDateString: string | Date): string => {
  const istDate = convertUTCtoIST(utcDateString)
  return new Intl.DateTimeFormat("en-GB", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).format(istDate)
}

/**
 * Formats IST date and time for display
 */
export const formatISTDateTime = (utcDateString: string | Date): string => {
  return new Intl.DateTimeFormat("en-IN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
    timeZone: "Asia/Kolkata", // Using IST timezone
  }).format(new Date(utcDateString))
}

/**
 * Formats IST date for display in date group headers
 */
export const formatISTDateDisplay = (istDate: Date): string => {
  return istDate.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  })
}